"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Backdrop = exports.Cover = exports.Loader = exports.ViewText = exports.ViewButton = exports.ViewContainer = exports.CompareButton = exports.TotalProducts = exports.LoadingContainer = exports.LoadMoreButton = exports.LoadMoreContainer = exports.ProductsAmount = exports.FilterButtonContainer = exports.FilterButton = exports.ErrorText = exports.ErrorContainer = exports.CatalogDescription = exports.TopRow = exports.RelativeCol = exports.FilterCol = exports.FamiliesContainer = exports.Row = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const Typography_1 = __importDefault(require("@/Components/UI/Typography"));
const RotatingLoader_1 = __importDefault(require("@/Components/UI/RotatingLoader/RotatingLoader"));
const Button_1 = __importDefault(require("../../../Button"));
exports.Row = (0, styled_components_1.default)(styled_bootstrap_grid_1.Row) `
  justify-content: center;
`;
exports.FamiliesContainer = styled_components_1.default.div `
  border-top: 1px solid ${props => props.theme.palette.DARK_GRAY_20};
  padding-top: ${props => props.theme.spacing.m5}px;
`;
exports.FilterCol = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  padding: ${props => props.isFilterOpen && 0};
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    max-width: 0%;
  }
`;
exports.RelativeCol = (0, styled_components_1.default)(styled_bootstrap_grid_1.Col) `
  position: relative;
  ${props => props.transparent && 'opacity: 0.5;'}
  @media (max-width: ${props => props.theme.breakpoints.lg}px) {
    width: 100%;
  }
`;
exports.TopRow = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
exports.CatalogDescription = (0, styled_components_1.default)(Typography_1.default) `
  margin: ${props => props.theme.spacing.l3}px 0 ${props => props.theme.spacing.m1}px 0;

  @media (max-width: ${props => props.theme.breakpoints.sm}px) {
    margin-top: ${props => props.theme.spacing.l1}px;
  }
`;
exports.ErrorContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  margin-top: ${props => props.theme.spacing.s4}px;
`;
exports.ErrorText = (0, styled_components_1.default)(Typography_1.default) `
  font-weight: ${props => props.theme.typography.weight.medium};
`;
exports.FilterButton = (0, styled_components_1.default)(Button_1.default) `
  width: 100%;
  background-color: ${props => props.theme.palette.BW_100};
  color: ${props => props.theme.palette.LIGHT_BLACK};
  border: 1px solid ${props => props.theme.palette.UI_BORDER_DARK};
  margin-bottom: ${props => props.theme.spacing.m1}px;
  font-weight: ${props => props.theme.typography.weight.regular};
`;
exports.FilterButtonContainer = styled_components_1.default.div `
  padding-bottom: ${props => props.theme.spacing.s4}px;
  border-bottom: 1px solid ${props => props.theme.palette.DARK_GRAY_20};
`;
exports.ProductsAmount = (0, styled_components_1.default)(Typography_1.default) `
  margin: 0;
`;
exports.LoadMoreContainer = styled_components_1.default.div `
  margin-top: ${props => props.theme.spacing.m5}px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    justify-content: center;
    flex-direction: column;
  }
`;
exports.LoadMoreButton = (0, styled_components_1.default)(Button_1.default) `
  font-size: ${props => props.theme.typography.size.s3}px;
  height: ${props => props.theme.constants.searchShowMoreButton.inTabHeight}px;
  padding: ${props => props.theme.constants.searchShowMoreButton.paddingVertical}px
    ${props => props.theme.constants.searchShowMoreButton.paddingHorizontal}px;
`;
exports.LoadingContainer = styled_components_1.default.div `
  display: flex;
  flex-grow: 1;
  justify-content: center;

  @media (max-width: ${props => props.theme.breakpoints.md}px) {
    margin-top: ${props => props.theme.spacing.s4}px;
  }
`;
exports.TotalProducts = (0, styled_components_1.default)(Typography_1.default) `
  display: flex;
  align-items: center;
  height: ${props => props.theme.constants.listingPage.totalProductsHeight}px;
  padding-right: ${props => props.theme.spacing.s4}px;
`;
exports.CompareButton = (0, styled_components_1.default)(Button_1.default) `
  background-color: ${props => props.theme.palette.ORANGE_100};
  border: none;
  color: ${props => props.theme.palette.BW_100};
  font-size: ${props => props.theme.typography.size.s2}px;
  font-weight: ${props => props.theme.typography.weight.regular};
  padding: ${props => props.theme.spacing.s2}px ${props => props.theme.spacing.s4}px;

  &:disabled {
    background-color: ${props => props.theme.palette.LIGHT_GRAY_30};
    color: ${props => props.theme.palette.UI_DISABLED_DETAIL};
  }
`;
exports.ViewContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
`;
exports.ViewButton = (0, styled_components_1.default)(Button_1.default) `
  display: flex;
  flex-direction: row;
  padding: 0;
`;
exports.ViewText = (0, styled_components_1.default)(Typography_1.default) `
  color: ${props => (props.isActive ? props.theme.palette.DARK_GRAY_80 : props.theme.palette.DARK_GRAY_40)};
  margin: 0 ${props => props.theme.spacing.s2}px 0 ${props => props.theme.spacing.s4}px;
`;
exports.Loader = (0, styled_components_1.default)(RotatingLoader_1.default) `
  margin: 0 ${props => props.theme.spacing.s4}px;
`;
exports.Cover = styled_components_1.default.div `
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: ${props => props.theme.attributes.zIndex.gradientOverlay};
`;
exports.Backdrop = styled_components_1.default.div `
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: ${props => props.theme.palette.WARNING_BLACK};
  opacity: 0.7;
  z-index: ${props => props.theme.attributes.zIndex.overHeader};
`;
exports.default = {
    Row: exports.Row,
    Backdrop: exports.Backdrop
};
